import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation ConfirmIntentSelection($input: ChatIntentInput!) {
    confirmIntentSelection(input: $input)
  }
`);
